$('.menu a').on('click', function(){
    $('#mobile-menu-trigger').prop('checked', false);
});

$('body').keydown(function(event){

    if( event.keyCode === 27 ) {
        $('#mobile-menu-trigger').prop('checked', false);
    }

});
